(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["guya-welcome"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('guya-welcome')) {
    customElements.define('guya-welcome', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = {signal: this.controller.signal};
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        document.addEventListener('click', event => {
          const trigger = event.target.closest('[data-guya-offer-trigger]');
          if (!trigger || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          if (this.dialog.open) return;
          this.opener = trigger;
          this.dialog.showModal();
          this.querySelector('[data-guya-offer-close]').focus();
        }, options);
        this.querySelectorAll('[data-guya-offer-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
        this.dialog.addEventListener('click', event => {
          if (event.target === this.dialog) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          if (this.opener?.isConnected) this.opener.focus();
        }, options);
      }
      disconnectedCallback() {this.controller?.abort();}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
